export const TAB_GROUPS = {
  language: {
    id: "language",
    title: "Language",
    options: [
      "Ruby",
      "JavaScript",
      "Elixir",
      "Python",
      "Node.js",
      "PHP",
      "Go",
      "Java",
    ],
    cookieName: "preferredCodeLanguage",
  },
  os: {
    id: "os",
    title: "Operating System",
    options: ["macOS", "Ubuntu / Debian"],
    cookieName: "preferredCodeOs",
  },
};
